module.exports = __webpack_public_path__ + "static/acoples-6f2eecf5f04a02e2f7b22b9bcedbd4ba.png";